// extracted by mini-css-extract-plugin
module.exports = {"modalStyle":"style_modalStyle__JP8IS","contentStyle":"style_contentStyle__L_XRa","btn":"style_btn__B5cIn","closeIcon":"style_closeIcon__vBP2m"};